import React from "react";
import { ExternalLink } from "lucide-react";
import { SPECTRALOOM_URL, UI } from "@/lib/constants";

export const Footer = ({ lang = "IT" }) => {
  const t = UI[lang];
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-[#2D3748] bg-[#0B0D12]"
    >
      <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <div className="flex items-center gap-3">
            <img src="/spectraloom-logo.jpg" alt="Spectraloom" className="h-10 w-10 rounded-lg object-contain bg-[#0B0D12]" />
            <span className="font-heading text-xl font-bold tracking-tight text-white">
              Spectraloom
            </span>
          </div>
          <p className="text-[#94A3B8] text-sm mt-3 max-w-sm">{t.footerTagline}</p>
        </div>
        <div className="flex flex-col items-start md:items-end gap-3">
          <a
            data-testid="footer-spectraloom-link"
            href={SPECTRALOOM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#8B5CF6] hover:text-[#a78bfa] transition-colors"
          >
            {t.visit} <ExternalLink className="w-4 h-4" />
          </a>
          <p className="text-xs text-[#64748B]">
            © {new Date().getFullYear()} Spectraloom. All rights reserved.
          </p>
        </div>
      </div>
      <div className="border-t border-[#2D3748]">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <p data-testid="ai-disclosure" className="text-center" style={{ fontSize: "0.8em", opacity: 0.45, color: "#64748B" }}>
            {t.aiDisclosure}
          </p>
        </div>
      </div>
    </footer>
  );
};
